import {Injectable} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class ModalService {
  constructor(private modalService: NgbModal) {}

  openCustomModal(component, data = null, size = 'lg', backdropClass = '', windowClass = 'modal'): NgbModalRef {
    const modalRef = this.modalService.open(component, {centered: true, backdropClass, backdrop: 'static', windowClass, size});

    if (modalRef.componentInstance) {
      modalRef.componentInstance.data = data;
    }

    return modalRef;
  }
}
